export default {
  path: '/lvy-notary-service-agreement2',
  component: () => import('./LvyNotaryServiceAgreement2'),
  meta: {
    title: '中大公证处服务协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}